import { render, staticRenderFns } from "./EditInfoCard.vue?vue&type=template&id=1e4a5679&"
import script from "./EditInfoCard.vue?vue&type=script&lang=js&"
export * from "./EditInfoCard.vue?vue&type=script&lang=js&"
import style0 from "./EditInfoCard.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports